import {Card, Flex, theme, Typography} from 'antd';
import React from 'react';
import {format, isDate} from 'date-fns';
import {useData} from 'Context/DataContext';
import {DATE_FORMAT} from 'Utils/constants/DateFormat';
import {TRANSACTIONS} from 'Pages/Tabs/Transactions/transactionConstants';
import styles from './styles';

const {Text, Title} = Typography;

interface IProps {
  item?: any;
  toggleView?: any;
  handleItem?: any;
  disabled?: boolean;
  showRefulfill?: boolean;
}

const TableItemCard: React.FC<IProps> = (props) => {
  const {item, toggleView = null, handleItem = null, disabled = false} = props;
  const {activeTab} = useData();
  const {token}: any = theme.useToken();

  const handleSelection = () => {
    if (disabled) return;
    toggleView();
    handleItem(item);
  };

  return (
    <Card
      hoverable={!disabled}
      onClick={handleSelection}
      style={{
        borderColor: token.colorBorderSecondary,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        marginBottom: 16,
      }}
      styles={{body: styles.cardActionArea}}>
      {/* TITLE */}
      <Title level={4} style={{...styles.title, color: token.colorPrimary}}>
        {item.offerTitle}
      </Title>
      {/* one row multiple columns */}
      <Flex gap="5%">
        {/* claim and expiry */}
        <Flex vertical justify="space-between" style={{width: '40%'}}>
          <Text>
            <strong>{TRANSACTIONS.card_field_map.claimDate} </strong>
            {item.claimDate &&
              isDate(new Date(item.claimDate)) &&
              format(new Date(item.claimDate), DATE_FORMAT.dateFormat)}
          </Text>
          {/* TODO this field might change name in backend to offerenddate for transactions*/}
          {item.expiryDate && (
            <Text>
              <strong>
                {activeTab === 1
                  ? TRANSACTIONS.card_field_map.offerEndDate
                  : TRANSACTIONS.card_field_map.expiryDate}{' '}
              </strong>
              {item.expiryDate &&
                isDate(new Date(item.expiryDate)) &&
                format(new Date(item.expiryDate), DATE_FORMAT.dateFormat)}
            </Text>
          )}
        </Flex>
        {/* vendor name */}
        <Flex vertical style={{width: '30%'}}>
          <Text>{item.merchantName}</Text>
        </Flex>

        {/* type and status */}
        <Flex vertical>
          <Text>
            {TRANSACTIONS.card_field_map.type}{' '}
            <strong style={{textTransform: 'capitalize'}}>{item.offerType}</strong>
          </Text>
          <Text>
            {TRANSACTIONS.card_field_map.status}{' '}
            <strong style={{textTransform: 'capitalize'}}>{item.transactionStatus}</strong>
          </Text>
        </Flex>
      </Flex>
    </Card>
  );
};

export default TableItemCard;
